<template>
  <div class="Login signup">
    <v-container fill-height class="mainBackG h-100 loginMain">
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 sm12 lg9 style="margin:auto">
          <div class="white card-r pt-4 pb-3 pl-4 pr-3  no-shadow">
            <v-toolbar class="primary card-r text-white">
              <router-link to="/adminprofile#PurchasedPackage" class="no-deraction">
                <v-btn icon flat class="card-r white mr-3">
                  <v-icon class="textColor left">keyboard_arrow_left</v-icon>
                </v-btn>
              </router-link>

              <div class="text-xs-left text-capitalize f-20">Billing Information (Optional)</div>
            </v-toolbar>
            <v-form row class="mt-3">
              <template>
                <v-stepper v-model="createSchool" class="card-r no-shadow grey lighten-4">
                  <!--<v-divider/>-->
                  <v-layout wrap>
                    <v-flex md3 sm3 xs3 lg3 class="">
                      <v-stepper-header class=" card-r no-shadow ">
                        <v-stepper-step xs4 :complete="createSchool > 4" step="4">Billing info</v-stepper-step>
                        <v-stepper-step xs4 :complete="createSchool > 5" step="5">Credit card info</v-stepper-step>
                      </v-stepper-header>
                    </v-flex>

                    <v-flex md9 sm12 xs12 lg9 class=" ">
                      <v-stepper-items class="grey lighten-4">
                        <v-stepper-content step="4">

                                    <!-- <v-chip>Your selected package</v-chip> -->
                          <div class="text-xs-left f-17 textColor pl-1 font-weight-bold">Billing Information (Optional)</div>
                          <!--<div class="text-xs-center f-15 pa-2">Step 4 of 5</div>-->
                           <v-flex xs12 sm6 d-flex>
                              <v-select
                                :items="cardDetails"
                                label="Select existing card"
                                item-text="card_number"
                                item-value="id"
                                v-model="selectedCard"
                                outline
                                @change="setCardDetails(selectedCard)"
                              >
                              </v-select>
                            </v-flex>

                          <form >

                            <v-card class="text-xs-center card-r no-shadow" color="transparent">
                              <!-- Club Details -->
                              <v-layout row wrap>

                                <!-- <v-flex md12 sm12 xs12 class="0">
                                  <v-checkbox label="Same as already given" v-model="sameAsBefore" @change="billingSameAsBefore"></v-checkbox>
                                </v-flex> -->
                                <v-flex xs12 lg4 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="Full name"
                                    label="Full name"
                                    v-model="fullname"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="Address"
                                    label="Address"
                                    type="text"
                                    v-model="address"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 lg4 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="City"
                                    label="City"
                                    type="text"
                                    v-model="city"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 lg4 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="Zip code"
                                    label="Zip code"
                                    type="text"
                                    v-model="Zipcode"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 lg4 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="Country"
                                    label="Country"
                                    type="text"
                                    v-model="Country"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-btn color="primary right card-r no-shadow"  @click="createSchool = 5">Next</v-btn>
                          </form>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                          <div class="text-xs-left f-17 textColor pl-1 font-weight-bold">Card Information</div>
                          <!--<div class="text-xs-center f-15 pa-2">Step 5 of 5</div>-->
                          <form >
                            <v-card class="text-xs-center card-r no-shadow" color="transparent">
                              <!-- Club Details -->
                              <v-layout row wrap>
                                <v-flex md12 wrap sm12 xs12 class="0">
                                  <div class="card-type "></div>
                                  <div class="card-type mastercard"></div>
                                  <div class="card-type visa"></div>
                                  <div class="card-type amex"></div>
                                  <div class="card-type discover"></div>
                                </v-flex>

                                <v-flex xs12 lg6 class="pa-1 hide-pro">
                                <v-text-field solo
                                        name="Card Holder Name"
                                        label="Card Holder Name"
                                        v-model="card_holder_name"
                                        class=" input-group--focused mt-0"
                                        required
                                ></v-text-field>
                              </v-flex>
                                <v-flex xs12 lg6 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    placeholder="0000 0000 0000 0000"
                                    name="Card Number"
                                    label="Card Number"
                                    maxlength="16"
                                    v-model="card_number"
                                    class=" input-group--focused mt-0"
                                    required
                                    @change="selectedCard=''"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 lg3 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="Expire Date"
                                    label="Expire Date"
                                    type="text"
                                    maxlength="5"
                                    placeholder="mm/yy"
                                    v-model="expiration_date"
                                    class=" input-group--focused mt-0"
                                    required
                                    @input="checkdate"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 lg3 class="pa-1 hide-pro">
                                  <v-text-field solo
                                    name="CVV"
                                    label="CVV"
                                    maxlength="3"
                                    v-model="cvd"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-flex xs12 class="text-xs-center">
                                <v-progress-circular
                                    indeterminate
                                    v-if=loading1
                                    color="primary"
                                ></v-progress-circular>
                                <v-alert
                                  :value="true"
                                  color="success"
                                  icon="check_circle"
                                  v-if="alert.type=='success'"
                                  outline
                                >
                                  {{alert.msg}}
                                </v-alert>
                                <v-alert
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                  v-if="alert.type=='warning'"
                                  outline
                                >
                                  {{alert.msg}}
                                </v-alert>
                            </v-flex>
                            <ConfirmSignup v-bind:value1="card_number" v-bind:value2="expiration_date" v-on:confirmyes="save()"/>
                            <v-btn @click="createSchool =  4 " class="right grey text-white card-r no-shadow">Back</v-btn>
                          </form>
                        </v-stepper-content>

                      </v-stepper-items>
                    </v-flex>
                  </v-layout>
                </v-stepper>

              </template>
            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>
<script>
	/* eslint-disable */
	import ConfirmDialog from "@/components/ConfirmDialog.vue";
	import ConfirmBooking from "@/components/ConfirmBooking.vue";
  import ConfirmPackage from "@/components/ConfirmPackage.vue";
  import ConfirmSignup from "@/components/auth/ConfirmSignup.vue";
	import OpenDays from "./OpenDays.vue";
	import { dispatch, mapState, mapActions, Store, mapMutations } from "vuex";
	import VueDawa from "vue-dawa";
  import api from "../../utils/backend-api.js"
  import router from '@/router'

	export default {
		data: () => ({
            //payment details
      sameAsBefore:false,
      package_id:'',
      card_number:'',
      expiration_date:'',
      expiration_month:'',
      expiration_year:'',
      cvd:'',
      card_holder_name:'',
      fullname:'',
      address:'',
      city:'',
      Zipcode:'',
      Country:'',

      createSchool: 0,
      policy:false,
      policyerror:"false",
      SelectedPackageId:'',
			file:'',
			clubAddress: {
				oneLineAddress: ""
			},
			adminAddress: {
				oneLineAddress: ""
			},
			modal: false,
			modal2: false,
			modal3: false,
			passwordShow: false,
			// Club

			logoURL: "",
			coverPhotoURL: "",
			attachment: {
				photos: [],
				photosURL: [],
				videos: [],
				videosURL: []
			},
			gender_: ["Male", "Female"],
			valid: false,
			name: "",
			numberRules: [
				v => !!v || "Mobile number is required",
				v => (v && v.length <= 8) || "Mobile number must be 8 characters"
			],
			requiredRule: [v => !!v || "This field is required"],
			email: "",
			emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
			],

			passwordRules: [
				v => !!v || "Password is required",
				v => (v && v.length > 6) || "Password must be grater than 6 characters. Use lower case, upper case & special characters"
      ],
      days:['Monday','Tuesday','Wednesday','Thursday','Friday'],
      openDaysAndTime:{
          openDays:[],
          startTime:[],
          closeTime:[]
      },
      cardDetails:[],
      selectedCard:'',
      processName:'',
      alert:{
        type:"",
        msg:''
      },
      loading1:false
		}),

		computed: {
			...mapState({
				loading: "loading",
				mode: "mode",
				admin: "admin",
				club: "club",
        adminPackages:"adminPackages",
				package: "package",
				snackbar: "snackbar",
				notice: "notice",
				timeout: "timeout",
				tempAdminId: "tempAdminId",
				user: "user"
      }),
      ...mapMutations({
        setClubAdminNull: 'setClubAdminNull'
      })
		},

		methods: {
      loadExistCards(){
        // api.getDa
      },
      setCardDetails(selectedCardId){
        let fullname,address,city,Zipcode,Country,card_number,card_holder_name
        console.log(selectedCardId)
        this.cardDetails.forEach(function(element,index){
          if(element.id==selectedCardId){
            console.log(element)
            fullname=element.fullname
            console.log(fullname)
            address=element.address
            city=element.city
            Zipcode=element.zip
            Country=element.country
            card_number=element.card_number
            card_holder_name=element.card_holder_name
          }
        })
        this.fullname=fullname
        this.city=address
        this.city=city
        this.Zipcode=Zipcode
        this.card_number=card_number
        this.card_holder_name=card_holder_name
        this.expiration_date="xx/xx"
        this.cvd="xxx"
      },
      billingSameAsBefore(){
          if(this.sameAsBefore==true){
            this.fullname=this.$store.state.user.card_details[0].fullname
            this.address=this.$store.state.user.card_details[0].address
            this.city=this.$store.state.user.card_details[0].city
            this.Zipcode=this.$store.state.user.card_details[0].zip
            this.Country=this.$store.state.user.card_details[0].country
          }
          console.log(this.$store.state.user)
      },
      checkdate(){
        if(this.expiration_date.length==2){
              this.expiration_date=this.expiration_date+'/'
        }
      },

      choosePackage(packageId){
        this.SelectedPackageId=packageId
      },
			...mapActions(["loadAdminPackages", "addAdmin", "addClub"]),
			selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
			},

			translateData(address) {
				if (!address || !address.data) {
					return;
				}
				return {
					id: address.data.id,
					street: address.data.vejnavn,
					streetNumber: address.data.husnr,
					floor: address.data.etage,
					door: address.data.dør,
					zipCode: address.data.postnr,
					city: address.data.postnrnavn,
					oneLineAddress: address.tekst
				};
      },
			save() {
        this.loading1=true
        console.log(this.alert)
        // var promise= new Promise(function(resolve,reject){
        let selectedCard,package_id,card_number,expiration_date,cvd,fullname,address,city,hasCard,card_holder_name
        if(this.processName=="changepackage"){
          console.log(this.alert)
          selectedCard=this.selectedCard
          package_id=this.$route.params.packId
          card_number=this.card_number
          expiration_date=this.expiration_date
          cvd=this.cvd
          fullname=this.fullname
          address=this.address
          card_holder_name=this.card_holder_name
          city=this.city
          hasCard=false
          var alertt={
            type:'',
            msg:''
          }
          var funcLoading=true
          let alert=function(type,msg,loading){
            alertt.type=type
            alertt.msg=msg
            funcLoading=loading
          }
              // this.cardDetails.forEach(function(element,index){

                for(let x=0;x<this.cardDetails.length;x++){
                  if(selectedCard==this.cardDetails[x].id){
                    let card_id=selectedCard
                    let Data={
                      card_id:card_id,
                      package_id:package_id
                    }
                    hasCard=true
                    api.postData('admin/pay/change',Data)
                    .then(res=>{
                      if(res.status==201){
                        alert("success","Successfully change package",false)
                      }else{
                        alert("warning","Failed to buy new package",false)
                      }
                    }).catch(error=>{
                        alert("warning","Failed to buy new package",false)
                    })
                  }
              }


              if(!hasCard){
                    this.loading1-true
                    console.log(card_number)
                    let expiration_month=expiration_date.substring(0,2)
                    let expiration_year=expiration_date.substring(3,7)
                    var paymentDetails={
                      'package_id':package_id,
                      'card_number':card_number,
                      'expiration_month':expiration_month,
                      'expiration_year':expiration_year,
                      'cvd':cvd,
                      'card_holder_name':card_holder_name,
                      'address':address,
                      'city':city,
                    }
                    api.postData('admin/change_card',paymentDetails)
                    .then(res=>{
                      if(res.status!=201){
                        alert("warning","Check your card details",false)
                      }
                      let card_id=res.data.card_id
                      let Data={
                        card_id:card_id,
                        package_id:package_id
                      }
                      api.postData('admin/pay/change',Data)
                      .then(res=>{
                        if(res.status==201){
                            alert("success","Successfully changed package",false)
                            router.push('/adminprofile#PurchasedPackage')

                        }
                      }).catch(err=>{
                        alert("warning","Change package is failed",false)
                      })
                    }).catch(error=>{
                        alert("warning","Check your card informations",false)
                    })
              }
          setTimeout(() => {
            this.loading1=funcLoading
            this.alert=alertt
          }, 5000);

        }else{
          console.log(this.loading1)
          let expiration_month=this.expiration_date.substring(0,2)
          let expiration_year=this.expiration_date.substring(3,7)
            var paymentDetails={
              'package_id':this.package_id,
              'card_number':this.card_number,
              'expiration_month':expiration_month,
              'expiration_year':expiration_year,
              'cvd':this.cvd,
              'card_holder_name':this.card_holder_name,
              'address':this.address,
              'city':this.city,
            }
            // this.$store.commit('setLoading', { loading: true })
            // this.$store.dispatch('AddPayment',paymentDetails).then(res=>{
            //   // this.$store.commit('setLoading', { loading: false })
            // })
            api.postData('admin/pay/new', paymentDetails)
            .then(res => {
              if(res.status==201){
                this.loading1=false
                this.alert.type="success"
                this.alert.msg="Successfully paid"
              }else{
                this.loading1=false
                this.alert.type="warning"
                this.alert.msg="Check your informations"
              }
            })
            .catch((error) => {
                this.loading1=false
                this.alert.type="warning"
                this.alert.msg="Check your informations"
            })

        }

      },
      selectPackage(packageid){
      },
			onPickLogo() {
				this.$refs.logoInput.click();
			},
			OnLogoPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				this.club.club_logo = fileName;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				this.club.club_logo = files[0];

				this.club.club_logo_name = files[0].name;

			},
			onPickCover() {
				this.$refs.CoverInput.click();
			},
			OnCoverPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				this.club.club_cover=files[0];


				this.club.club_cover_name = files[0].name;

			},
			onPickImg() {
				this.$refs.ImgInput.click();
			},
			onPickVideo() {
				this.$refs.VideoInput.click();
			},
			onImgPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.photosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.photos.push(files[0]);
			},
			onVideoPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.videosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.videos.push(files[0]);
      },
      setDaysAndTime(Data){
        this.openDaysAndTime.openDays=Data.Days;
        this.openDaysAndTime.startTime=Data.startTime;
        this.openDaysAndTime.closeTime=Data.closeTime;
      }
		},
		components: {
			ConfirmBooking,
      ConfirmDialog,
      ConfirmPackage,
			VueDawa,
      OpenDays,
      ConfirmSignup

		},
		created() {
      this.loadExistCards()
      let packId=this.$route.params.packId
      if(packId){
        this.processName="changepackage"
      }
      console.log(this.$store)
      this.cardDetails=this.$store.state.user.card_details
      let productId=this.$route.params.id
      if(productId){
        this.package_id=productId
      }else{
        console.log(this.$store.state)
      }

    }
	};
</script>

<style>
  .transparent{
    background-color: transparent!important;
  }
  .card-type {
    display: none;
    width: 80px;
    height: 56px;
    background: url("../../assets/cards.png");
    background-position: 0 -291px;
    background-repeat: no-repeat;
  }
  .card-type.mastercard {
    background-position: 0 0;
  }
  .card-type.visa {
    background-position: 0 -115px;
  }
  .card-type.amex {
    background-position: 0 -57px;
  }
  .card-type.discover {
    background-position: 0 -174px;
  }
  .v-stepper__header {
    margin: 24px 0px 0px 20px ;
    display: table;
    overflow: hidden;
  }
  .signup .theme--light.v-stepper {
    height: 77vh;
    /*height: 378px;*/
    overflow: -moz-scrollbars-none;
  }
  .signup .Formcard{
    height: -webkit-fill-available!important;
  }
  .signup .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #fff;
    padding: 15px;
    font-size: 12px;
  }
  .signup .v-stepper__step{
    /*padding:  11px 48px 11px 20px;*/
    padding: 0px 39px 45px 0px!important;
  }
  .signup .v-stepper__content {
    overflow: auto;
    height: -webkit-fill-available;
    /*height: 100%;*/
  }
  /* Smartphones (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .signup .v-stepper__header{
      display: none!important;
    }
    .signup .v-stepper__content{
      padding: 0px !important;
    }
    .signup .Formcard {
      height: -webkit-fill-available!important;
    }
  }
  .v-dialog{
    box-shadow: none!important;
  }
  /* Smartphones (landscape) ----------- */
  @media only screen and (min-width : 321px){
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* Smartphones (portrait) ----------- */
  @media only screen and (max-width : 320px) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }


  /* iPhone 4 ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }



  /* iPads (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (portrait) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPad 3 ---------------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }


  /* Desktops and laptops ----------- */
  @media only screen and (min-width : 1224px) {
    .signup .v-stepper__header{
      display: table!important;
    }
  }

  /* 960px layouts ----------- */
  @media only screen and (min-width : 960px){
    .signup .v-stepper__header{
      display: table!important;
    }
  }

  /* Large screens ----------- */
  @media only screen and (min-width : 1824px) {
    .signup .v-stepper__header{
      display: table!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Signup2.vue